import { USER_INFO_KEY } from "@/utils/constants";

export default defineNuxtPlugin(() => {
  if (!import.meta.client) return;

  const { loadCategories } = useBackCategoryLoader();
  void loadCategories();

  const authStore = useAuthStore();
  const userInfoJson = localStorage.getItem(USER_INFO_KEY);
  authStore.setUserInfo(userInfoJson ? JSON.parse(userInfoJson) : null);
});
